import React, { Component } from "react"
import PropTypes from "prop-types"

import styles from "./InputField.module.sass"
import { cleanUpNumber } from "../../../lib/numerFormattingHelper"
import { formatNumber } from "lib/NumberHelper"
import { v4 } from "uuid"

class InputField extends Component {
  static propTypes = {
    id: PropTypes.string,
    focused: PropTypes.bool,
    className: PropTypes.string,
    prefix: PropTypes.any,
    type: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    onKeyUp: PropTypes.func,
    onKeyDown: PropTypes.func,
    value: PropTypes.any,
    openRight: PropTypes.bool,
    openLeft: PropTypes.bool,
    autoFocus: PropTypes.bool,
    locale: PropTypes.string,
    inputPlaceholder: PropTypes.string,
    label: PropTypes.string,
    inputClassName: PropTypes.string,
    prefixClassName: PropTypes.string,
    "aria-describedby": PropTypes.string,
    "aria-invalid": PropTypes.string,
    autocomplete: PropTypes.string,
  }

  constructor(props) {
    super(props)
    this.inputRef = React.createRef()
    this.id = this.props.id ?? `input-field-${v4()}`
  }

  componentDidMount() {
    if (this.props.focused) this.focusInput()
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.focused && this.props.focused !== prevProps.focused) {
      this.focusInput()
    }
  }

  focusInput() {
    this.inputRef.current.focus()
  }

  onChange = (e) => {
    this.props.onChange(e.target.value)
  }

  onNumberChange = (e) => {
    const value = cleanUpNumber(e.target.value)
    this.props.onChange(value)
  }



  render() {
    return (
      <>
        {this.props.label && (
          <label className={styles.label} htmlFor={this.id}>
            {this.props.label}
          </label>
        )}
        <div
          className={[
            styles.inputContainer,
            this.props.className,
            this.props.openRight && styles.openRight,
            this.props.openLeft && styles.openLeft,
          ].join(" ")}
        >
          {this.props.prefix && (
            <span
              data-testid="prefix"
              className={`${styles.prefix} ${
                this.props.prefixClassName && this.props.prefixClassName
              }`}
            >
              {this.props.prefix}
            </span>
          )}
          <input
            id={this.id}
            className={`unstyled ${styles.input} ${
              this.props.inputClassName && this.props.inputClassName
            }`}
            type={
              this.props.type === "number"
                ? "tel"
                : this.props.type === "email"
                ? "email"
                : "text"
            }
            onChange={
              this.props.type === "number" ? this.onNumberChange : this.onChange
            }
            onBlur={this.props.onBlur}
            onFocus={this.props.onFocus}
            onKeyUp={this.props.onKeyUp}
            onKeyDown={this.props.onKeyDown}
            value={
              this.props.type === "number" && this.props.value
                ? formatNumber(this.props.value, this.props.locale)
                : this.props.value
            }
            ref={this.inputRef}
            autoFocus={this.props.autoFocus}
            placeholder={this.props.inputPlaceholder}
            aria-describedby={this.props["aria-describedby"]}
            aria-invalid={this.props["aria-invalid"]}
            autoComplete={this.props.autocomplete}
          />
        </div>
      </>
    )
  }
}

export default InputField
